import React from 'react';
import { compose, pure } from 'recompose';
import PropTypes from 'prop-types';

const ParseHtml = ({ html }) => (
  /* eslint-disable */
  <div dangerouslySetInnerHTML={{ __html: html }} />
)

export default compose(pure)(ParseHtml);

ParseHtml.propTypes = {
  html: PropTypes.string,
}